<div class="article-type-attributes">
  <sc-padding>
    <ng-container *ngFor="let group of getNonDeletedAttributeGroups()">
      <div>
        <app-dictionary-entry-label [model]="group.name"></app-dictionary-entry-label>
        <button mat-icon-button (click)="editAttributeGroup(group)">
          <sc-action-icon iconClass="fa-pencil"></sc-action-icon>
        </button>
        <button mat-icon-button (click)="removeAttributeGroup(group)">
          <sc-action-icon iconClass="fa-trash"></sc-action-icon>
        </button>
      </div>
      <table class="table">
        <tr *ngFor="let attribute of getNonDeletedAttributes(group); let i = index">
          <td class="text-selection column-index">{{i+1}}</td>
          <td class="text-selection column-type">
            <sc-icon iconClass="fa-input-text" *ngIf="attribute.type === 'STRING'" matTooltip="STRING"></sc-icon>
            <sc-icon iconClass="fa-text" *ngIf="attribute.type === 'TEXT'" matTooltip="TEXT"></sc-icon>
            <sc-icon iconClass="fa-input-numeric" *ngIf="attribute.type === 'NUMBER'" matTooltip="NUMBER"></sc-icon>
            <sc-icon iconClass="fa-input-numeric" *ngIf="attribute.type === 'DECIMAL'" matTooltip="DECIMAL"></sc-icon>
            <sc-icon iconClass="fa-square-check" *ngIf="attribute.type === 'BOOLEAN'" matTooltip="BOOLEAN"></sc-icon>
            <sc-icon iconClass="fa-calendar" *ngIf="attribute.type === 'DATE'" matTooltip="DATE"></sc-icon>
            <sc-icon iconClass="fa-ballot-check" *ngIf="attribute.type === 'LOOKUP'" matTooltip="LOOKUP"></sc-icon>
          </td>
          <td class="text-selection column-name">
            <div>
            <span [ngClass]="{ 'mandatory': attribute.mandatory }">
              <app-dictionary-entry-label [model]="attribute.name"></app-dictionary-entry-label>
            </span>
            <span *ngIf="attribute.mandatory">*</span>
          </div>
          <div *ngIf="attribute.type === 'LOOKUP'" style="font-style: italic;">
            <ng-container *ngFor="let value of attribute.values; let i = index">
              <span *ngIf="value.deleted === false">
                <span *ngIf="i > 0">, </span>{{value.value}}
              </span>
            </ng-container>
          </div>
          </td>
          <td class="column-action">
            <button mat-icon-button (click)="editAttribute(attribute, group)">
              <sc-action-icon iconClass="fa-pencil"></sc-action-icon>
            </button>
            <button mat-icon-button (click)="removeAttribute(attribute, group)">
              <sc-action-icon iconClass="fa-trash"></sc-action-icon>
            </button>
          </td>
        </tr>
      </table>
    </ng-container>
  </sc-padding>
</div>
